(function (window) {
	"use strict";
	function defineHttpResponseCodeHelper() {
		var httpResponseCode = {};
		httpResponseCode.code = {
			unauthorized: 401,
			ok: 200,
			notFound: 404
		};
		return httpResponseCode;
	}
	//define globally if it doesn't already exist
	if (typeof (httpResponseCode) === "undefined") {
		window.httpResponseCode = defineHttpResponseCodeHelper();
	} else {
		console.log("httpResponseCode already defined.");
	}
})(window);